import { flexPoolService } from 'ogp/services';
import { useMutation } from 'react-query';

export const useDeleteFlexPool = () => {
  const mutationFn = async (flexPoolId: string) => await flexPoolService.deleteFlexPool(flexPoolId);

  return useMutation(mutationFn);
};
